
import firebase from 'firebase';
import * as dataManager from '../adapters/data';
import React, {useState, useContext} from 'react';
import styled from 'styled-components';
import {useHistory} from 'react-router-dom';
import { GlobalContext } from '../contexts/GlobalContext';
import HeroDiv from '../components/HeroDiv';

const FlexContainer = styled.div`
    display: flex;

    overflow: hidden;

    @media screen and (max-width: 1068px) {
        flex-direction: column;
    }
`;



const LoginDiv = styled.div`
    // padding-top: 272px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 375px;
    min-width: 375px;

    // @media screen and (max-width: 1068px) {
    //     // padding-top: 80px;
    //     max-width: unset;
    //     // min-width: 100%;
    //     width: 70vw;
    //     outline: 2px solid red;
    // }


    @media screen and (max-width: 1068px) {
        max-width: 100vw;
        min-width: 100vw;
        padding-top: 40px;
        padding-bottom: 10vh;
    }

    @media screen and (max-width: 425px) {
        max-width: 100vw;
        min-width: 100vw;
    }
`;

const LoginHeading = styled.text`
    

    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 54px;


    /* primary-black-text */

    color: #464646;
`;

const LoginForm = styled.form`
    // padding-left: 51px;
    display: flex;
    flex-direction: column;
`;

const Input = styled.input`
    border-radius: 9px;
    height: 43px;
    margin-bottom: 33px;
    width: 271px;
    padding-left: 56px;

    background: url(${props => props.icon}) 12px no-repeat;

`;

const LoginButton = styled.button`
    color: #fff;
    background: #1D599B;
    border: none;
    border-radius: 9px;
    height: 44px;
    width: 271px;

    :hover {
        cursor: pointer;
    }
`;

const SecondaryText = styled.text`
    margin-top: 58px;
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 27px;

    // text-align: center;
    // margin: 0 auto;

    /* primary-black-text */

    color: #464646;

`;

const ErrorText = styled.text`
    color: red;
    margin-top: 33px;
    max-width: 271px;
`;

const CenterDiv = styled.div`
    margin:auto;
    text-align: center;
`;



const Login = (props) => {

    const [email, setEmail] = useState('test@email.com');
    const [password, setPassword] = useState('password');
    const [message, setMessage] = useState('');

    const [state, setState] = useContext(GlobalContext);

    const history = useHistory();

    const updateEmail = (e) => {
        setEmail(e.target.value);
    }

    const updatePassword = (e) => {
        setPassword(e.target.value);
    }

    const loginUser = (e) => {
        e.preventDefault();

        if (email.trim() === '' || password.trim() === '') {
            setMessage('Please fill out all fields.');
        }

        else {

            firebase.auth().signInWithEmailAndPassword(email, password).then( cred => {
                console.log(cred);
                let load = dataManager.loadState();
                let saveObject = {...load, user: cred.user, showDropFileComponent: true, selectedCells: []};

                setMessage('Logged in as ' + email);
                // localStorage.setItem('user', JSON.stringify(cred.user));
                setState( (prev) => {
                    dataManager.saveState( saveObject );
                    
                    return saveObject
                });
                history.push('/home');
                
            })
            
            .catch( (error) => {
                let errorCode = error.code;
                let errorMessage = error.message;
                console.log(errorCode, errorMessage);

                // invalid email/password error
                if (errorCode === 'auth/wrong-passord' || errorCode === 'auth/user-not-found') {
                    setMessage('Invalid Email/Password');
                }

                // invalid email address format error
                else if (errorCode === 'auth/invalid-email') {
                    setMessage('Invalid email address. Please use a correct email address.');
                }

                else {
                    setMessage(errorMessage);
                }
            });

        }

    }

    return (

        <FlexContainer>

            <HeroDiv />
            
            <LoginDiv>

                <LoginForm onSubmit={loginUser}>
                    <LoginHeading>Login</LoginHeading> <br />
                    <Input defaultValue='test@email.com' icon='carbon_email.svg' type="email" name='email' id='email' placeholder='Email' aria-label='Email' onChange={updateEmail} />
                    <Input defaultValue='password' icon='carbon_password.svg' type="password" name="password" placeholder='Password' aria-label='Password' id="password" onChange={updatePassword} />
                    <LoginButton type="submit">Login</LoginButton>
                </LoginForm>
                <ErrorText>{message}</ErrorText>

                <SecondaryText>Don't have an account? <a href='/register'>Register</a> </SecondaryText>
            </LoginDiv>

        </FlexContainer>

    );
};

export default Login;